<template>
  <div id="site-header" :class="{ home: $store.state.pagename == '홈' }">
    <div class="container">
      <router-link class="navigation-est-go-home" v-if="$store.state.isProcessor" :to="{ name: 'Home' }" tag="button"></router-link>
      <button class="navigation-back" type="button" @click="back" v-if="!$store.state.isProcessor">
        <i class="material-icons" v-if="$route.name != 'Home'">arrow_back_ios</i>
      </button>

      <h1 class="navigation-home">
        <router-link :to="{ name: 'Home' }">
          <img alt="Insunet FC" :src="'/static/header_logo_ci2_en.png'">
        </router-link>
      </h1>

      <div class="navigation-search">
        <button @click="isSearchVisible = !isSearchVisible">
          <img alt="검색" src="/static/search2.png" />
        </button>
      </div>

      <h2 v-if="$store.state.pagename != '홈'">{{ $store.state.pagename }}</h2>
      <nav id="gnb">
        <ul>
          <li :class="{ 'on' : isPageName( '비교견적' ) }" @mouseover="mouseOver('비교견적')" @mouseleave="mouseLeave('비교견적')"><router-link :to="{ name: 'CompareEstimate', query: { tab: '자동차보험' } }">비교견적</router-link></li>
          <li :class="{ 'on' : isPageName( '5대보증' ) }" @mouseover="mouseOver('5대보증')" @mouseleave="mouseLeave('5대보증')"><router-link :to="{ name: 'Guarantee', query: { tab: '최저 보험료' } }">5대 보증</router-link></li>
          <li :class="{ 'on' : isPageName( '6대사은' ) }" @mouseover="mouseOver('6대사은')" @mouseleave="mouseLeave('6대사은')"><router-link :to="{ name: 'Gift', query: { tab: '24시간 주차알림' } }">6대 사은</router-link></li>
          <li :class="{ 'on' : isPageName( '보험정보' ) }" @mouseover="mouseOver('보험정보')" @mouseleave="mouseLeave('보험정보')"><router-link :to="{ name: 'Contents' }">보험정보</router-link></li>
          <li :class="{ 'on' : isPageName( 'MY보험' ) }" @mouseover="mouseOver('MY보험')" @mouseleave="mouseLeave('MY보험')"><router-link :to="{ name: 'MyInsurance', query: { tab: '비교견적', subtab: '전체' } }">MY 보험</router-link></li>
          <li :class="{ 'on' : isPageName( '회사소개' ) }" @mouseover="mouseOver('회사소개')" @mouseleave="mouseLeave('회사소개')"><router-link :to="{ name: 'Overview' }">회사개요</router-link></li>
          <!--<li :class="{ 'on' : isPageName( '대리점등록증' ) }" @mouseover="mouseOver('대리점등록증')" @mouseleave="mouseLeave('대리점등록증')"><router-link :to="{ name: 'Certificate' }">대리점등록증</router-link></li>-->
          <!--<li :class="{ 'on' : isPageName( '고객센터') }" @mouseover="mouseOver('고객센터')" @mouseleave="mouseLeave('고객센터')"><router-link :to="{ name: 'Notice' }">고객센터</router-link></li>-->
          <!--<li><router-link :to="{ name: 'Home' }"><i class="material-icons">menu</i></router-link></li>-->
          <li class="lh">
            <div class="cs-help">
              <img alt="고객센터 전화번호" src="/static/call.png"/>
              <p @click="callNumber">1668-1100</p>
            </div>
          </li>
        </ul>
      </nav>

      <button id="mobile-nav-toggle" @click="openMobileNav">
        <i class="material-icons">menu</i>
      </button>

      <div id="mobile-nav" v-if="mobileNavOpened">
        <div class="container">
          <div>
            <button class="go-home" @click="gohome"><i class="fa fa-home"></i></button>
            <button class="close" @click="closeMobileNav"></button>
          </div>

          <nav>
            <ul>

              <li
                v-for="(tab, index) in TabList"
                :class="{ on: openedTab.indexOf( tab.name ) >= 0 }"
                :key="index"
              >
                <template v-if="tab.list">
                  <div class="primary" @click="toggleTab( tab.name )">
                    {{ tab.name }}
                    <i class="material-icons">expand_less</i>
                  </div>

                  <div class="secondary" v-if="openedTab.indexOf( tab.name ) >= 0">
                    <ul>
                      <li v-for="(subtab, index) in tab.list" :key="index">
                        <router-link :to="{ name: subtab.target, query: { tab: subtab.query } }">
                          <span @click="toggleTab( tab.name )">{{ subtab.name }}</span>
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </template>
                <template v-else>
                  <div class="primary">
                    <router-link :to="{ name: tab.target }">{{ tab.name }}</router-link>
                  </div>
                </template>
              </li>
            </ul>
          </nav>
        </div>
      </div>

    </div>

    <div id="snb" class="navigation-hover" v-if="hoverAreaStatus" @mouseover="mouseOver('navi')" @mouseleave="mouseLeave('navi')">
      <div class="container">
        <ul v-for="(items, index) in TabList" :key="index" class="navigation-hover-item">
          <template v-if="items.name == hoverTab">
            <li v-for="(list, index) in items.list" :key="index">
              <router-link :to="{ name: list.target, query: { tab: list.query } }">{{ list.name || "&nbsp;" }}</router-link>
            </li>
          </template>
        </ul>
      </div>
    </div>

    <div class="search" :class="{ on: isSearchVisible }">
      <form class="search-form">
        <input type="search" placeholder="검색어를 입력해주세요." />
        <button type="submit">
          <i class="material-icons">search</i>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return{
      hoverTabStatus: false,
      hoverAreaStatus: false,
      hoverTab: '',
      openedTab: [],
      mobileNavOpened: false,
      isSearchVisible: false,
      TabList: [
        { 'name': '비교견적', 'target': 'CompareEstimate', 'list': [
          { 'name': '자동차보험', 'target': 'CompareEstimate', 'query': '자동차보험' },
          { 'name': '운전자보험', 'target': 'CompareEstimate', 'query': '운전자보험' },
          { 'name': '실손의료보험', 'target': 'CompareEstimate', 'query': '실손의료보험' },
          { 'name': '암/2대질병 보험', 'target': 'CompareEstimate', 'query': '암/2대질병 보험' },
          { 'name': '어린이보험', 'target': 'CompareEstimate', 'query': '어린이보험' },
          { 'name': '태아보험', 'target': 'CompareEstimate', 'query': '태아보험' },
          { 'name': '정기보험', 'target': 'CompareEstimate', 'query': '정기보험' },
          { 'name': '종신보험', 'target': 'CompareEstimate', 'query': '종신보험' },
          { 'name': '화재보험', 'target': 'CompareEstimate', 'query': '화재보험' },
          { 'name': '연금보험', 'target': 'CompareEstimate', 'query': '연금보험' },
          { 'name': '치아보험', 'target': 'CompareEstimate', 'query': '치아보험' },
          { 'name': '치매보험', 'target': 'CompareEstimate', 'query': '치매보험' },
          { 'name': '펫보험', 'target': 'CompareEstimate', 'query': '펫보험' },
          { 'name': '원데이자동차보험', 'target': 'CompareEstimate', 'query': '원데이자동차보험' },
          { 'name': '여행보험', 'target': 'CompareEstimate', 'query': '여행보험' },
          { 'name': '', 'target': '', 'query': '' },
          { 'name': '', 'target': '', 'query': '' },
          { 'name': '', 'target': '', 'query': '' } ] },
        { 'name': '5대보증', 'target': 'Guarantee', 'query': '최저 보험료', 'list': [
          { 'name': '최저보험료', 'target': 'Guarantee', 'query': '최저 보험료' },
          { 'name': '만기완결 알림', 'target': 'Guarantee', 'query': '만기완결 알림' },
          { 'name': '청약철회 환불', 'target': 'Guarantee', 'query': '청약철회 환불' },
          { 'name': '착오계약 리콜', 'target': 'Guarantee', 'query': '착오계약 리콜' },
          { 'name': '24시간 근무', 'target': 'Guarantee', 'query': '24시간 근무' },
          { 'name': '', 'target': '', 'query': '' },
          { 'name': '', 'target': '', 'query': '' },
          { 'name': '', 'target': '', 'query': '' } ] },
        { 'name': '6대사은', 'target': 'Gift', 'query': '24시간 주차알림', 'list': [
          { 'name': '24시간 주차알림', 'target': 'Gift', 'query': '24시간 주차알림' },
          { 'name': '긴급견인 20km 추가', 'target': 'Gift', 'query': '긴급견인 20km 추가' },
          { 'name': '응급치료비 지원', 'target': 'Gift', 'query': '응급치료비 지원' },
          { 'name': '12개 보험사 비교견적', 'target': 'Gift', 'query': '12개 보험사 비교견적' },
          { 'name': '4대 공개 게시판', 'target': 'Gift', 'query': '4대 공개 게시판' },
          { 'name': 'SNS 보험 정보', 'target': 'Gift', 'query': 'SNS 보험 정보' },
          { 'name': '', 'target': '', 'query': '' },
          { 'name': '', 'target': '', 'query': '' } ] },
        {
          name: '보험정보',
          target: 'Contents',
          query: '카드뉴스',
          list: [
            { name: '카드뉴스', target: 'Contents' },
            { name: '이벤트', target: 'Events' },
          ]
        },
        { 'name': 'MY보험', 'target': 'MyInsurance', 'query': '비교견적', 'list': [
          { 'name': '비교견적', 'target': 'MyInsurance', 'query': '비교견적'},
          { 'name': '가입보험', 'target': 'MyInsurance', 'query': '가입보험'},
          { 'name': '계약변경', 'target': 'MyInsurance', 'query': '계약변경'},
          { 'name': '사고보상', 'target': 'MyInsurance', 'query': '사고보상'},
          { 'name': '나의 질문과 답변', 'target': 'FAQ', 'query': '자동차' },
          //{ 'name': '고객정보관리', 'target': 'MyPage', 'query': '' },
          { 'name': '', 'target': '', 'query': '' },
          { 'name': '', 'target': '', 'query': '' } ] },
        { 'name': '회사소개', 'target': 'Overview', 'list': [
          { 'name': '회사개요', 'target': 'Overview', 'query': '' },
          { 'name': '주요연혁', 'target': 'History', 'query': '' },
          { 'name': '위치안내', 'target': 'Location', 'query': '' },
          { 'name': '제휴보험사', 'target': 'Alliance', 'query': '' },
          { 'name': '대리점등록증', 'target': 'Certificate', 'query': '' },
          /*{ 'name': '채용정보', 'target': 'Overview', 'query': '' },
          { 'name': '', 'target': '', 'query': '' },
          { 'name': '', 'target': '', 'query': '' },
          { 'name': '', 'target': '', 'query': '' }*/ ] },
        /*{ 'name': '고객센터', 'target': 'Notice', 'list': [
          { 'name': '공지사항', 'target': 'Notice', 'query': '' },
          { 'name': '4대 공개 게시판', 'target': 'BulletinBoard', 'query': '' },
          { 'name': '자주하는 질문', 'target': 'FAQ', 'query': '' },
          { 'name': '보험자료실', 'target': 'InsuranceResources', 'query': '' } ] }*/
    ],
    }
  },
  mounted(){
    // <!-- Hotjar Tracking Code for www.insunetfc.com -->
    (function(h, o, t, j, a, r) {
      h.hj = h.hj || function() {
        (h.hj.q = h.hj.q || []).push(arguments)
      };
      h._hjSettings = {
        hjid: 1815177,
        hjsv: 6
      };
      a = o.getElementById("site-header");
      r = o.createElement('script');
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');

    this.$trackingService('init', '001-004-761');
    this.$trackingService('track', 'PageView');

    /* WCS */
    this.$nextTick(() => {
      if(this.$route.query && this.$route.query.procstep &&
          (
            this.$route.query.procstep == '비교견적 신청이 완료되었습니다.' || this.$route.query.procstep == '전화상담 예약이 완료되었습니다.'
          )) {
        this.wsclog_cnv(() => {
          this.wcslog_init()
          this.wsclog_member()
        })
        this.$once("hook:beforeDestroy", () => {
          window._nasa = null
        })
        this.kakaoCTS_init()
      }else{
        this.wcslog_init();
        this.wsclog_member()
        this.$trackingService('init', '001-004-761');
        this.$trackingService('track', 'ViewContent');
      }
    })
  },
  created(){
    this.$watch( "$route", () => {
      this.hoverTabStatus = false;
      this.hoverAreaStatus = false;
      this.closeMobileNav();
    })
  },
  methods: {
    kakaoCTS_init() {
      window.DaumConversionDctSv="type=M,orderID=,amount=";
      window.DaumConversionAccountID="-u6Hg.AvFLZaroFPd5CW8A00";
      if(typeof window.DaumConversionScriptLoaded=="undefined" && location.protocol != "file:"){
        window.DaumConversionScriptLoaded = true;
      }

      /* <script type="text//javascript" src="https://t1.daumcdn.net/cssjs/common/cts/vr200/dcts.js"><//script>*/
      if(document.querySelector("#kakaocts")) document.querySelector("#kakaocts").remove()
      var head = document.querySelector("head")
      var tag = document.createElement('script')
      tag.src = "https://t1.daumcdn.net/cssjs/common/cts/vr200/dcts.js"
      tag.type = "text/javascript"
      tag.id = "kakaocts"
      head.appendChild(tag)
    },
    wcslog_init(){
      var sh = document.getElementById("site-header")
      var tag = document.createElement('script')
      tag.src = "https://wcs.naver.net/wcslog.js"
      tag.type = "text/javascript"
      tag.async = true
      tag.onload = function(){
        var code_tag = document.createElement('script')
        code_tag.text = `
          console.log("wcslog-init", _nasa);
          if(!window.wcs_add) var wcs_add = {};
          wcs_add["wa"] = "s_38887c875497";
          if (!_nasa) var _nasa={};
          wcs.inflow();
          wcs_do(_nasa);
          `;
        sh.appendChild(code_tag)
      }
      sh.appendChild(tag)
    },
    wsclog_cnv(cb) {
      var sh = document.getElementById("site-header")
      var tag = document.createElement('script')
      tag.src = "https://wcs.naver.net/wcslog.js"
      tag.type = "text/javascript"
      tag.async = true
      tag.onload = () => {
        var code_tag = document.createElement('script')
        code_tag.text = `
          console.log("wcslog-cnv");
          var _nasa={};
          _nasa["cnv"] = wcs.cnv("4","1");
          `;
        sh.appendChild(code_tag)
        cb()
      }
      sh.appendChild(tag)
    },
    wsclog_member() {
      const sh = document.body
      const tag = document.createElement('script')
      const {profile} = this.$store.state.customer
      tag.type = "text/javascript"
      tag.text = `var hpt_trace_info={'_mode':'q','_memid': ${profile ? profile._id : ''}}; var hpt_info={'_account':'UHPT-15642'};`
      sh.appendChild(tag)
      const smlogTag = document.createElement('script')
      smlogTag.language = "javascript"
      smlogTag.src = "//a21.smlog.co.kr/smart.js"
      smlogTag.charset = "utf-8"
      sh.appendChild(smlogTag)
    },
    openMobileNav(){
      this.mobileNavOpened = true;
    },
    closeMobileNav(){
      this.mobileNavOpened = false;
    },
    gohome() {
      this.mobileNavOpened = false;
      this.$router.push({ name: 'Home' }).catch(err => {});
    },

    toggleTab( tabName ){
      console.log("click");
      if( this.openedTab.indexOf( tabName ) >= 0 ){
        this.openedTab = this.openedTab.filter( o => o != tabName );
      }else{
        this.openedTab.push( tabName );
      };
    },

    back(){
      if( this.$store.state.isProcessor ){
        var backConfirm = confirm( "작성중인 견적서를 폐기하시겠습니까?" );
        if( backConfirm ){
          history.back();
        };
      }else{
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

        if (isSafari) {
          this.$router.replace({ path: this.$store.state.prev });
        }
        this.$router.go(-1);
      };
    },
    isPageName( page ){
      if(page === this.$store.state.pagename){
        return true;
      }
      else{
        return false;
      }
    },
    mouseOver(name){
      this.hoverTabStatus = true;
      this.hoverAreaStatus = true;
      if(name !== 'navi'){
        this.hoverTab = name;
      }
    },
    mouseLeave(name){
      this.hoverTabStatus = false;
      if(name == 'navi'){
        this.hoverAreaStatus = false;
      }
    },
    callNumber() {
      location.href = "tel:16681100";
    }
  }
}
</script>
